class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.currentPage = 1;
    this.totalPages = parseInt(this.dataset.totalPages) || 1;
    this.loading = false;
    this.sectionId = this.dataset.sectionId;
    this.collectionUrl = this.dataset.collectionUrl;
  }

  connectedCallback() {
    if (this.totalPages <= 1) return;

    this.grid = document.getElementById('main-collection-product-grid');
    this.loadingIndicator = this.querySelector('.infinite-scroll__loading');
    this.sentinel = this.querySelector('.infinite-scroll__sentinel');

    if (!this.sentinel || !this.grid) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.loading && this.currentPage < this.totalPages) {
            this.loadNextPage();
          }
        });
      },
      {
        rootMargin: '200px',
        threshold: 0
      }
    );

    this.observer.observe(this.sentinel);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  async loadNextPage() {
    this.loading = true;
    this.currentPage++;

    if (this.loadingIndicator) {
      this.loadingIndicator.classList.add('is-loading');
    }

    try {
      const url = new URL(this.collectionUrl, window.location.origin);
      url.searchParams.set('page', this.currentPage);
      url.searchParams.set('section_id', this.sectionId);

      // Preserve existing query parameters (filters, sort, etc.)
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.forEach((value, key) => {
        if (key !== 'page' && key !== 'section_id') {
          url.searchParams.set(key, value);
        }
      });

      const response = await fetch(url.toString());
      const text = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');
      const newProducts = doc.querySelectorAll('#main-collection-product-grid > div');

      if (newProducts.length > 0) {
        newProducts.forEach((product) => {
          // Update lazy loading for images
          const images = product.querySelectorAll('img[loading="lazy"]');
          images.forEach(img => {
            img.setAttribute('loading', 'lazy');
          });
          this.grid.appendChild(product);
        });
      }

      // Update URL without reload
      const newUrl = new URL(window.location);
      newUrl.searchParams.set('page', this.currentPage);
      window.history.replaceState({}, '', newUrl);

      // Check if we've reached the last page
      if (this.currentPage >= this.totalPages) {
        this.sentinel.style.display = 'none';
        if (this.observer) {
          this.observer.disconnect();
        }
      }
    } catch (error) {
      console.error('Error loading more products:', error);
      this.currentPage--;
    } finally {
      this.loading = false;
      if (this.loadingIndicator) {
        this.loadingIndicator.classList.remove('is-loading');
      }
    }
  }
}

customElements.define('infinite-scroll', InfiniteScroll);
